import SessionTable from './SessionTable';

export default SessionTable;
